import React from "react";

const FormatItalicIcon = ({ color = "black" }) => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M6 15V18H14V15H11.79L15.21 7H18V4H10V7H12.21L8.79 15H6Z" fill="white" />
	</svg>
);

export default FormatItalicIcon;
